"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RECORD_PROTECTION_RESPONSE_EXAMPLE = void 0;
exports.RECORD_PROTECTION_RESPONSE_EXAMPLE = {
    id: '66666666-6666-6666-6666-666666666666',
    tenantId: '11111111-1111-1111-1111-111111111111',
    protectedEntityType: 'Patient',
    protectedEntityId: '22222222-2222-2222-2222-222222222222',
    protectionCategory: 'LEGAL',
    protectionTypeId: 'lookup-legal-hold',
    searchRestricted: false,
    printRestricted: false,
    exportRestricted: false,
    apiRestricted: false,
    mergeRestricted: true,
    deleteRestricted: true,
    archiveRestricted: true,
    editRestricted: false,
    visibilityLevel: 'NORMAL',
    durationType: 'PERMANENT',
    expiresAt: null,
    reasonCode: 'MLC',
    reasonDescription: null,
    status: 'ACTIVE',
    appliedBy: '99999999-9999-9999-9999-999999999999',
    appliedAt: '2026-07-10T09:00:00.000Z',
    releasedBy: null,
    releasedAt: null,
    createdAt: '2026-07-10T09:00:00.000Z',
    updatedAt: '2026-07-10T09:00:00.000Z',
};
//# sourceMappingURL=protection.response.js.map